export default {
  Required: 'required', // Bắt buộc
  NotEqual: 'notEqual', // Không bắng (chưa xử lý)
  Pattern: 'pattern', // Theo 1 mẫu (email, phone, ...)
  ForceSelection: 'forceSelection', // chỉ cho chọn
  NotSelectParent: 'notSelectParent', // Không chọn parent
}
